import "./OTAListingOptimizationServices2.module.css";
import Header from "@/reusable_sections/Header";
import Otahero from "./sections/Otahero";
import OtaEcosystemExpertise from "./sections/OtaEcosystemExpertise";
import Strategy from "./sections/Strategy";
import ManagedPlatformOverview from "./sections/ManagedPlatformOverview";
import Performanceresults from "./sections/Performanceresults";
import Faq from "./sections/Faq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function OTAListingOptimizationServices2Page() {
  return <div>
      <Header />
      <Otahero />
      <OtaEcosystemExpertise />
      <Strategy />
      <ManagedPlatformOverview />
      <Performanceresults />
      <Faq />
      <Services />
      <Footer />
    </div>;
}